// Stable root slugs
export const skyShowtimeSlug = 'skyshowtime';
export const nordiskFilmSlug = 'nordisk-film';
export const viaplaySlug = 'viaplay';
export const tv2playSlug = 'tv-2-play';
export const nrkSlug = 'nrk-tv-start';
export const maxSlug = 'max';
export const bbcNordicSlug = 'bbc-nordic-';
